import { useEffect } from "react";
import _ from "lodash";
import { AppURLParams } from "utils/urls";
import type { FamiliesResponse } from "../types";

export const useInitFamilyIndexFromURL = (families: FamiliesResponse, setResultFamilyIndex: (index: number) => void): void => {
  useEffect(() => {
    if (AppURLParams.family_id !== null) {
      const idx = _.findIndex(families.data.families, (family) => family.id === AppURLParams.family_id);
      setResultFamilyIndex(idx);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // URL hydration: runs once on mount only
};
